module.exports = __webpack_public_path__ + "img/success4.d344afa3.svg";